module.exports = __webpack_public_path__ + "static/media/Acc-1c.8b75733a.png";